// Untitled UI v8 (Tailwind v4) design tokens backported to Tailwind v3.
import type { Config } from "tailwindcss";

type ThemeExtend = NonNullable<Config["theme"]>["extend"];

export const untitledTokens = {
	colors: {
		white: "var(--color-white)",
		black: "var(--color-black)",
		"neutral-50": "var(--color-neutral-50)",
		"neutral-100": "var(--color-neutral-100)",
		"neutral-200": "var(--color-neutral-200)",
		"neutral-300": "var(--color-neutral-300)",
		"neutral-400": "var(--color-neutral-400)",
		"neutral-500": "var(--color-neutral-500)",
		"neutral-600": "var(--color-neutral-600)",
		"neutral-700": "var(--color-neutral-700)",
		"neutral-800": "var(--color-neutral-800)",
		"neutral-900": "var(--color-neutral-900)",
		"neutral-950": "var(--color-neutral-950)",
		"red-50": "var(--color-red-50)",
		"red-100": "var(--color-red-100)",
		"red-200": "var(--color-red-200)",
		"red-300": "var(--color-red-300)",
		"red-400": "var(--color-red-400)",
		"red-500": "var(--color-red-500)",
		"red-600": "var(--color-red-600)",
		"red-700": "var(--color-red-700)",
		"red-800": "var(--color-red-800)",
		"red-900": "var(--color-red-900)",
		"red-950": "var(--color-red-950)",
		"yellow-50": "var(--color-yellow-50)",
		"yellow-100": "var(--color-yellow-100)",
		"yellow-200": "var(--color-yellow-200)",
		"yellow-300": "var(--color-yellow-300)",
		"yellow-400": "var(--color-yellow-400)",
		"yellow-500": "var(--color-yellow-500)",
		"yellow-600": "var(--color-yellow-600)",
		"yellow-700": "var(--color-yellow-700)",
		"yellow-800": "var(--color-yellow-800)",
		"yellow-900": "var(--color-yellow-900)",
		"yellow-950": "var(--color-yellow-950)",
		"green-50": "var(--color-green-50)",
		"green-100": "var(--color-green-100)",
		"green-200": "var(--color-green-200)",
		"green-300": "var(--color-green-300)",
		"green-400": "var(--color-green-400)",
		"green-500": "var(--color-green-500)",
		"green-600": "var(--color-green-600)",
		"green-700": "var(--color-green-700)",
		"green-800": "var(--color-green-800)",
		"green-900": "var(--color-green-900)",
		"green-950": "var(--color-green-950)",
		"orange-50": "var(--color-orange-50)",
		"orange-100": "var(--color-orange-100)",
		"orange-200": "var(--color-orange-200)",
		"orange-300": "var(--color-orange-300)",
		"orange-400": "var(--color-orange-400)",
		"orange-500": "var(--color-orange-500)",
		"orange-600": "var(--color-orange-600)",
		"orange-700": "var(--color-orange-700)",
		"orange-800": "var(--color-orange-800)",
		"orange-900": "var(--color-orange-900)",
		"orange-950": "var(--color-orange-950)",
		"blue-50": "var(--color-blue-50)",
		"blue-100": "var(--color-blue-100)",
		"blue-200": "var(--color-blue-200)",
		"blue-300": "var(--color-blue-300)",
		"blue-400": "var(--color-blue-400)",
		"blue-500": "var(--color-blue-500)",
		"blue-600": "var(--color-blue-600)",
		"blue-700": "var(--color-blue-700)",
		"blue-800": "var(--color-blue-800)",
		"blue-900": "var(--color-blue-900)",
		"blue-950": "var(--color-blue-950)",
		"indigo-50": "var(--color-indigo-50)",
		"indigo-100": "var(--color-indigo-100)",
		"indigo-200": "var(--color-indigo-200)",
		"indigo-300": "var(--color-indigo-300)",
		"indigo-400": "var(--color-indigo-400)",
		"indigo-500": "var(--color-indigo-500)",
		"indigo-600": "var(--color-indigo-600)",
		"indigo-700": "var(--color-indigo-700)",
		"indigo-800": "var(--color-indigo-800)",
		"indigo-900": "var(--color-indigo-900)",
		"indigo-950": "var(--color-indigo-950)",
		"fuchsia-50": "var(--color-fuchsia-50)",
		"fuchsia-100": "var(--color-fuchsia-100)",
		"fuchsia-200": "var(--color-fuchsia-200)",
		"fuchsia-300": "var(--color-fuchsia-300)",
		"fuchsia-400": "var(--color-fuchsia-400)",
		"fuchsia-500": "var(--color-fuchsia-500)",
		"fuchsia-600": "var(--color-fuchsia-600)",
		"fuchsia-700": "var(--color-fuchsia-700)",
		"fuchsia-800": "var(--color-fuchsia-800)",
		"fuchsia-900": "var(--color-fuchsia-900)",
		"fuchsia-950": "var(--color-fuchsia-950)",
		"pink-50": "var(--color-pink-50)",
		"pink-100": "var(--color-pink-100)",
		"pink-200": "var(--color-pink-200)",
		"pink-300": "var(--color-pink-300)",
		"pink-400": "var(--color-pink-400)",
		"pink-500": "var(--color-pink-500)",
		"pink-600": "var(--color-pink-600)",
		"pink-700": "var(--color-pink-700)",
		"pink-800": "var(--color-pink-800)",
		"pink-900": "var(--color-pink-900)",
		"pink-950": "var(--color-pink-950)",
		"purple-50": "var(--color-purple-50)",
		"purple-100": "var(--color-purple-100)",
		"purple-200": "var(--color-purple-200)",
		"purple-300": "var(--color-purple-300)",
		"purple-400": "var(--color-purple-400)",
		"purple-500": "var(--color-purple-500)",
		"purple-600": "var(--color-purple-600)",
		"purple-700": "var(--color-purple-700)",
		"purple-800": "var(--color-purple-800)",
		"purple-900": "var(--color-purple-900)",
		"purple-950": "var(--color-purple-950)",
		"sky-50": "var(--color-sky-50)",
		"sky-100": "var(--color-sky-100)",
		"sky-200": "var(--color-sky-200)",
		"sky-300": "var(--color-sky-300)",
		"sky-400": "var(--color-sky-400)",
		"sky-500": "var(--color-sky-500)",
		"sky-600": "var(--color-sky-600)",
		"sky-700": "var(--color-sky-700)",
		"sky-800": "var(--color-sky-800)",
		"sky-900": "var(--color-sky-900)",
		"sky-950": "var(--color-sky-950)",
		"slate-50": "var(--color-slate-50)",
		"slate-100": "var(--color-slate-100)",
		"slate-200": "var(--color-slate-200)",
		"slate-300": "var(--color-slate-300)",
		"slate-400": "var(--color-slate-400)",
		"slate-500": "var(--color-slate-500)",
		"slate-600": "var(--color-slate-600)",
		"slate-700": "var(--color-slate-700)",
		"slate-800": "var(--color-slate-800)",
		"slate-900": "var(--color-slate-900)",
		"slate-950": "var(--color-slate-950)",
		"emerald-50": "var(--color-emerald-50)",
		"emerald-100": "var(--color-emerald-100)",
		"emerald-200": "var(--color-emerald-200)",
		"emerald-300": "var(--color-emerald-300)",
		"emerald-400": "var(--color-emerald-400)",
		"emerald-500": "var(--color-emerald-500)",
		"emerald-600": "var(--color-emerald-600)",
		"emerald-700": "var(--color-emerald-700)",
		"emerald-800": "var(--color-emerald-800)",
		"emerald-900": "var(--color-emerald-900)",
		"emerald-950": "var(--color-emerald-950)",
		"amber-50": "var(--color-amber-50)",
		"amber-100": "var(--color-amber-100)",
		"amber-200": "var(--color-amber-200)",
		"amber-300": "var(--color-amber-300)",
		"amber-400": "var(--color-amber-400)",
		"amber-500": "var(--color-amber-500)",
		"amber-600": "var(--color-amber-600)",
		"amber-700": "var(--color-amber-700)",
		"amber-800": "var(--color-amber-800)",
		"amber-900": "var(--color-amber-900)",
		"amber-950": "var(--color-amber-950)",
		"warning-50": "var(--color-warning-50)",
		"warning-100": "var(--color-warning-100)",
		"warning-200": "var(--color-warning-200)",
		"warning-300": "var(--color-warning-300)",
		"warning-400": "var(--color-warning-400)",
		"warning-500": "var(--color-warning-500)",
		"warning-600": "var(--color-warning-600)",
		"warning-700": "var(--color-warning-700)",
		"warning-800": "var(--color-warning-800)",
		"warning-900": "var(--color-warning-900)",
		"warning-950": "var(--color-warning-950)",
		transparent: "var(--color-transparent)",
		"alpha-white": "var(--color-alpha-white)",
		"alpha-black": "var(--color-alpha-black)",
		"brand-50": "var(--color-brand-50)",
		"brand-100": "var(--color-brand-100)",
		"brand-200": "var(--color-brand-200)",
		"brand-300": "var(--color-brand-300)",
		"brand-400": "var(--color-brand-400)",
		"brand-500": "var(--color-brand-500)",
		"brand-600": "var(--color-brand-600)",
		"brand-700": "var(--color-brand-700)",
		"brand-800": "var(--color-brand-800)",
		"brand-900": "var(--color-brand-900)",
		"brand-950": "var(--color-brand-950)",
		"utility-blue-50": "var(--color-utility-blue-50)",
		"utility-blue-100": "var(--color-utility-blue-100)",
		"utility-blue-200": "var(--color-utility-blue-200)",
		"utility-blue-300": "var(--color-utility-blue-300)",
		"utility-blue-400": "var(--color-utility-blue-400)",
		"utility-blue-500": "var(--color-utility-blue-500)",
		"utility-blue-600": "var(--color-utility-blue-600)",
		"utility-blue-700": "var(--color-utility-blue-700)",
		"utility-brand-50": "var(--color-utility-brand-50)",
		"utility-brand-50_alt": "var(--color-utility-brand-50_alt)",
		"utility-brand-100": "var(--color-utility-brand-100)",
		"utility-brand-100_alt": "var(--color-utility-brand-100_alt)",
		"utility-brand-200": "var(--color-utility-brand-200)",
		"utility-brand-200_alt": "var(--color-utility-brand-200_alt)",
		"utility-brand-300": "var(--color-utility-brand-300)",
		"utility-brand-300_alt": "var(--color-utility-brand-300_alt)",
		"utility-brand-400": "var(--color-utility-brand-400)",
		"utility-brand-400_alt": "var(--color-utility-brand-400_alt)",
		"utility-brand-500": "var(--color-utility-brand-500)",
		"utility-brand-500_alt": "var(--color-utility-brand-500_alt)",
		"utility-brand-600": "var(--color-utility-brand-600)",
		"utility-brand-600_alt": "var(--color-utility-brand-600_alt)",
		"utility-brand-700": "var(--color-utility-brand-700)",
		"utility-brand-700_alt": "var(--color-utility-brand-700_alt)",
		"utility-brand-800": "var(--color-utility-brand-800)",
		"utility-brand-800_alt": "var(--color-utility-brand-800_alt)",
		"utility-brand-900": "var(--color-utility-brand-900)",
		"utility-brand-900_alt": "var(--color-utility-brand-900_alt)",
		"utility-neutral-50": "var(--color-utility-neutral-50)",
		"utility-neutral-100": "var(--color-utility-neutral-100)",
		"utility-neutral-200": "var(--color-utility-neutral-200)",
		"utility-neutral-300": "var(--color-utility-neutral-300)",
		"utility-neutral-400": "var(--color-utility-neutral-400)",
		"utility-neutral-500": "var(--color-utility-neutral-500)",
		"utility-neutral-600": "var(--color-utility-neutral-600)",
		"utility-neutral-700": "var(--color-utility-neutral-700)",
		"utility-neutral-800": "var(--color-utility-neutral-800)",
		"utility-neutral-900": "var(--color-utility-neutral-900)",
		"utility-gray-50": "var(--color-utility-gray-50)",
		"utility-gray-100": "var(--color-utility-gray-100)",
		"utility-gray-200": "var(--color-utility-gray-200)",
		"utility-gray-300": "var(--color-utility-gray-300)",
		"utility-gray-400": "var(--color-utility-gray-400)",
		"utility-gray-500": "var(--color-utility-gray-500)",
		"utility-gray-600": "var(--color-utility-gray-600)",
		"utility-gray-700": "var(--color-utility-gray-700)",
		"utility-gray-800": "var(--color-utility-gray-800)",
		"utility-gray-900": "var(--color-utility-gray-900)",
		"utility-gray-950": "var(--color-utility-gray-950)",
		"utility-gray-blue-50": "var(--color-utility-gray-blue-50)",
		"utility-gray-blue-100": "var(--color-utility-gray-blue-100)",
		"utility-gray-blue-200": "var(--color-utility-gray-blue-200)",
		"utility-gray-blue-300": "var(--color-utility-gray-blue-300)",
		"utility-gray-blue-400": "var(--color-utility-gray-blue-400)",
		"utility-gray-blue-500": "var(--color-utility-gray-blue-500)",
		"utility-gray-blue-600": "var(--color-utility-gray-blue-600)",
		"utility-gray-blue-700": "var(--color-utility-gray-blue-700)",
		"utility-gray-blue-800": "var(--color-utility-gray-blue-800)",
		"utility-gray-blue-900": "var(--color-utility-gray-blue-900)",
		"utility-red-50": "var(--color-utility-red-50)",
		"utility-red-100": "var(--color-utility-red-100)",
		"utility-red-200": "var(--color-utility-red-200)",
		"utility-red-300": "var(--color-utility-red-300)",
		"utility-red-400": "var(--color-utility-red-400)",
		"utility-red-500": "var(--color-utility-red-500)",
		"utility-red-600": "var(--color-utility-red-600)",
		"utility-red-700": "var(--color-utility-red-700)",
		"utility-yellow-50": "var(--color-utility-yellow-50)",
		"utility-yellow-100": "var(--color-utility-yellow-100)",
		"utility-yellow-200": "var(--color-utility-yellow-200)",
		"utility-yellow-300": "var(--color-utility-yellow-300)",
		"utility-yellow-400": "var(--color-utility-yellow-400)",
		"utility-yellow-500": "var(--color-utility-yellow-500)",
		"utility-yellow-600": "var(--color-utility-yellow-600)",
		"utility-yellow-700": "var(--color-utility-yellow-700)",
		"utility-green-50": "var(--color-utility-green-50)",
		"utility-green-100": "var(--color-utility-green-100)",
		"utility-green-200": "var(--color-utility-green-200)",
		"utility-green-300": "var(--color-utility-green-300)",
		"utility-green-400": "var(--color-utility-green-400)",
		"utility-green-500": "var(--color-utility-green-500)",
		"utility-green-600": "var(--color-utility-green-600)",
		"utility-green-700": "var(--color-utility-green-700)",
		"utility-orange-50": "var(--color-utility-orange-50)",
		"utility-orange-100": "var(--color-utility-orange-100)",
		"utility-orange-200": "var(--color-utility-orange-200)",
		"utility-orange-300": "var(--color-utility-orange-300)",
		"utility-orange-400": "var(--color-utility-orange-400)",
		"utility-orange-500": "var(--color-utility-orange-500)",
		"utility-orange-600": "var(--color-utility-orange-600)",
		"utility-orange-700": "var(--color-utility-orange-700)",
		"utility-indigo-50": "var(--color-utility-indigo-50)",
		"utility-indigo-100": "var(--color-utility-indigo-100)",
		"utility-indigo-200": "var(--color-utility-indigo-200)",
		"utility-indigo-300": "var(--color-utility-indigo-300)",
		"utility-indigo-400": "var(--color-utility-indigo-400)",
		"utility-indigo-500": "var(--color-utility-indigo-500)",
		"utility-indigo-600": "var(--color-utility-indigo-600)",
		"utility-indigo-700": "var(--color-utility-indigo-700)",
		"utility-fuchsia-50": "var(--color-utility-fuchsia-50)",
		"utility-fuchsia-100": "var(--color-utility-fuchsia-100)",
		"utility-fuchsia-200": "var(--color-utility-fuchsia-200)",
		"utility-fuchsia-300": "var(--color-utility-fuchsia-300)",
		"utility-fuchsia-400": "var(--color-utility-fuchsia-400)",
		"utility-fuchsia-500": "var(--color-utility-fuchsia-500)",
		"utility-fuchsia-600": "var(--color-utility-fuchsia-600)",
		"utility-fuchsia-700": "var(--color-utility-fuchsia-700)",
		"utility-pink-50": "var(--color-utility-pink-50)",
		"utility-pink-100": "var(--color-utility-pink-100)",
		"utility-pink-200": "var(--color-utility-pink-200)",
		"utility-pink-300": "var(--color-utility-pink-300)",
		"utility-pink-400": "var(--color-utility-pink-400)",
		"utility-pink-500": "var(--color-utility-pink-500)",
		"utility-pink-600": "var(--color-utility-pink-600)",
		"utility-pink-700": "var(--color-utility-pink-700)",
		"utility-purple-50": "var(--color-utility-purple-50)",
		"utility-purple-100": "var(--color-utility-purple-100)",
		"utility-purple-200": "var(--color-utility-purple-200)",
		"utility-purple-300": "var(--color-utility-purple-300)",
		"utility-purple-400": "var(--color-utility-purple-400)",
		"utility-purple-500": "var(--color-utility-purple-500)",
		"utility-purple-600": "var(--color-utility-purple-600)",
		"utility-purple-700": "var(--color-utility-purple-700)",
		"utility-sky-50": "var(--color-utility-sky-50)",
		"utility-sky-100": "var(--color-utility-sky-100)",
		"utility-sky-200": "var(--color-utility-sky-200)",
		"utility-sky-300": "var(--color-utility-sky-300)",
		"utility-sky-400": "var(--color-utility-sky-400)",
		"utility-sky-500": "var(--color-utility-sky-500)",
		"utility-sky-600": "var(--color-utility-sky-600)",
		"utility-sky-700": "var(--color-utility-sky-700)",
		"utility-slate-50": "var(--color-utility-slate-50)",
		"utility-slate-100": "var(--color-utility-slate-100)",
		"utility-slate-200": "var(--color-utility-slate-200)",
		"utility-slate-300": "var(--color-utility-slate-300)",
		"utility-slate-400": "var(--color-utility-slate-400)",
		"utility-slate-500": "var(--color-utility-slate-500)",
		"utility-slate-600": "var(--color-utility-slate-600)",
		"utility-slate-700": "var(--color-utility-slate-700)",
		"utility-emerald-50": "var(--color-utility-emerald-50)",
		"utility-emerald-100": "var(--color-utility-emerald-100)",
		"utility-emerald-200": "var(--color-utility-emerald-200)",
		"utility-emerald-300": "var(--color-utility-emerald-300)",
		"utility-emerald-400": "var(--color-utility-emerald-400)",
		"utility-emerald-500": "var(--color-utility-emerald-500)",
		"utility-emerald-600": "var(--color-utility-emerald-600)",
		"utility-emerald-700": "var(--color-utility-emerald-700)",
		"utility-amber-50": "var(--color-utility-amber-50)",
		"utility-amber-100": "var(--color-utility-amber-100)",
		"utility-amber-200": "var(--color-utility-amber-200)",
		"utility-amber-300": "var(--color-utility-amber-300)",
		"utility-amber-400": "var(--color-utility-amber-400)",
		"utility-amber-500": "var(--color-utility-amber-500)",
		"utility-amber-600": "var(--color-utility-amber-600)",
		"utility-amber-700": "var(--color-utility-amber-700)",
		"utility-warning-50": "var(--color-utility-warning-50)",
		"utility-warning-100": "var(--color-utility-warning-100)",
		"utility-warning-200": "var(--color-utility-warning-200)",
		"utility-warning-300": "var(--color-utility-warning-300)",
		"utility-warning-400": "var(--color-utility-warning-400)",
		"utility-warning-500": "var(--color-utility-warning-500)",
		"utility-warning-600": "var(--color-utility-warning-600)",
		"utility-warning-700": "var(--color-utility-warning-700)",
		"text-primary": "var(--color-text-primary)",
		"text-tertiary": "var(--color-text-tertiary)",
		"text-error-primary": "var(--color-text-error-primary)",
		"text-warning-primary": "var(--color-text-warning-primary)",
		"text-success-primary": "var(--color-text-success-primary)",
		"text-secondary": "var(--color-text-secondary)",
		"text-secondary_hover": "var(--color-text-secondary_hover)",
		"text-tertiary_hover": "var(--color-text-tertiary_hover)",
		"text-brand-secondary": "var(--color-text-brand-secondary)",
		"text-placeholder": "var(--color-text-placeholder)",
		"text-brand-tertiary": "var(--color-text-brand-tertiary)",
		"text-editor-icon-fg": "var(--color-text-editor-icon-fg)",
		"text-editor-icon-fg_active": "var(--color-text-editor-icon-fg_active)",
		"text-quaternary": "var(--color-text-quaternary)",
		"text-brand-primary": "var(--color-text-brand-primary)",
		"text-primary_on-brand": "var(--color-text-primary_on-brand)",
		"text-secondary_on-brand": "var(--color-text-secondary_on-brand)",
		"text-tertiary_on-brand": "var(--color-text-tertiary_on-brand)",
		"text-quaternary_on-brand": "var(--color-text-quaternary_on-brand)",
		"text-brand-tertiary_alt": "var(--color-text-brand-tertiary_alt)",
		"text-error-primary_hover": "var(--color-text-error-primary_hover)",
		"text-brand-secondary_hover": "var(--color-text-brand-secondary_hover)",
		"border-primary": "var(--color-border-primary)",
		"border-secondary": "var(--color-border-secondary)",
		"border-secondary_alt": "var(--color-border-secondary_alt)",
		"border-tertiary": "var(--color-border-tertiary)",
		"border-error": "var(--color-border-error)",
		"border-error_subtle": "var(--color-border-error_subtle)",
		"border-brand": "var(--color-border-brand)",
		"border-brand_alt": "var(--color-border-brand_alt)",
		"fg-secondary": "var(--color-fg-secondary)",
		"fg-warning-primary": "var(--color-fg-warning-primary)",
		"fg-success-primary": "var(--color-fg-success-primary)",
		"fg-white": "var(--color-fg-white)",
		"fg-success-secondary": "var(--color-fg-success-secondary)",
		"fg-secondary_hover": "var(--color-fg-secondary_hover)",
		"fg-primary": "var(--color-fg-primary)",
		"fg-brand-secondary": "var(--color-fg-brand-secondary)",
		"fg-brand-primary": "var(--color-fg-brand-primary)",
		"quadrant-blue": "var(--color-quadrant-blue)",
		"fg-quaternary": "var(--color-fg-quaternary)",
		"fg-quaternary_hover": "var(--color-fg-quaternary_hover)",
		"fg-error-primary": "var(--color-fg-error-primary)",
		"fg-warning-secondary": "var(--color-fg-warning-secondary)",
		"fg-error-secondary": "var(--color-fg-error-secondary)",
		"fg-tertiary": "var(--color-fg-tertiary)",
		"fg-tertiary_hover": "var(--color-fg-tertiary_hover)",
		"fg-disabled_subtle": "var(--color-fg-disabled_subtle)",
		"fg-brand-primary_alt": "var(--color-fg-brand-primary_alt)",
		"fg-brand-secondary_alt": "var(--color-fg-brand-secondary_alt)",
		"fg-brand-secondary_hover": "var(--color-fg-brand-secondary_hover)",
		"bg-primary": "var(--color-bg-primary)",
		"bg-tertiary": "var(--color-bg-tertiary)",
		"bg-brand-primary": "var(--color-bg-brand-primary)",
		"bg-error-secondary": "var(--color-bg-error-secondary)",
		"bg-warning-primary": "var(--color-bg-warning-primary)",
		"bg-warning-secondary": "var(--color-bg-warning-secondary)",
		"bg-success-primary": "var(--color-bg-success-primary)",
		"bg-success-secondary": "var(--color-bg-success-secondary)",
		"bg-brand-solid": "var(--color-bg-brand-solid)",
		"bg-secondary-solid": "var(--color-bg-secondary-solid)",
		"bg-error-solid": "var(--color-bg-error-solid)",
		"bg-warning-solid": "var(--color-bg-warning-solid)",
		"bg-success-solid": "var(--color-bg-success-solid)",
		"bg-secondary_hover": "var(--color-bg-secondary_hover)",
		"bg-primary_hover": "var(--color-bg-primary_hover)",
		"bg-brand-solid_hover": "var(--color-bg-brand-solid_hover)",
		"bg-error-primary": "var(--color-bg-error-primary)",
		"bg-brand-secondary": "var(--color-bg-brand-secondary)",
		"bg-secondary": "var(--color-bg-secondary)",
		"bg-quaternary": "var(--color-bg-quaternary)",
		"bg-primary_alt": "var(--color-bg-primary_alt)",
		"bg-brand-primary_alt": "var(--color-bg-brand-primary_alt)",
		"bg-secondary_alt": "var(--color-bg-secondary_alt)",
		"bg-overlay": "var(--color-bg-overlay)",
		"bg-brand-section": "var(--color-bg-brand-section)",
		"bg-brand-section_subtle": "var(--color-bg-brand-section_subtle)",
		"bg-primary-solid": "var(--color-bg-primary-solid)",
		"bg-error-solid_hover": "var(--color-bg-error-solid_hover)",
		"app-store-badge-border": "var(--color-app-store-badge-border)",
		"avatar-styles-bg-neutral": "var(--color-avatar-styles-bg-neutral)",
		"featured-icon-light-fg-brand": "var(--color-featured-icon-light-fg-brand)",
		"featured-icon-light-fg-error": "var(--color-featured-icon-light-fg-error)",
		"featured-icon-light-fg-gray": "var(--color-featured-icon-light-fg-gray)",
		"featured-icon-light-fg-success":
			"var(--color-featured-icon-light-fg-success)",
		"featured-icon-light-fg-warning":
			"var(--color-featured-icon-light-fg-warning)",
		"focus-ring-error": "var(--color-focus-ring-error)",
		"focus-ring": "var(--color-focus-ring)",
		"footer-button-fg": "var(--color-footer-button-fg)",
		"footer-button-fg_hover": "var(--color-footer-button-fg_hover)",
		"icon-fg-brand": "var(--color-icon-fg-brand)",
		"icon-fg-brand_on-brand": "var(--color-icon-fg-brand_on-brand)",
		"screen-mockup-border": "var(--color-screen-mockup-border)",
		"slider-handle-bg": "var(--color-slider-handle-bg)",
		"slider-handle-border": "var(--color-slider-handle-border)",
		"toggle-border": "var(--color-toggle-border)",
		"toggle-slim-border_pressed-hover":
			"var(--color-toggle-slim-border_pressed-hover)",
		"toggle-slim-border_pressed": "var(--color-toggle-slim-border_pressed)",
		"tooltip-supporting-text": "var(--color-tooltip-supporting-text)",
		"text-white": "var(--color-text-white)",
	},
	backgroundColor: {
		tertiary: "var(--background-color-tertiary)",
		"brand-primary": "var(--background-color-brand-primary)",
		"error-secondary": "var(--background-color-error-secondary)",
		"warning-primary": "var(--background-color-warning-primary)",
		"warning-secondary": "var(--background-color-warning-secondary)",
		"success-primary": "var(--background-color-success-primary)",
		"success-secondary": "var(--background-color-success-secondary)",
		"brand-solid":
			"color-mix(in srgb, var(--background-color-brand-solid) calc(<alpha-value> * 100%), transparent)",
		"secondary-solid": "var(--background-color-secondary-solid)",
		"error-solid":
			"color-mix(in srgb, var(--background-color-error-solid) calc(<alpha-value> * 100%), transparent)",
		"warning-solid": "var(--background-color-warning-solid)",
		"success-solid":
			"color-mix(in srgb, var(--background-color-success-solid) calc(<alpha-value> * 100%), transparent)",
		secondary_hover: "var(--background-color-secondary_hover)",
		primary_hover: "var(--background-color-primary_hover)",
		"brand-solid_hover": "var(--background-color-brand-solid_hover)",
		"error-primary": "var(--background-color-error-primary)",
		"brand-secondary": "var(--background-color-brand-secondary)",
		quaternary:
			"color-mix(in srgb, var(--background-color-quaternary) calc(<alpha-value> * 100%), transparent)",
		primary_alt: "var(--background-color-primary_alt)",
		"brand-primary_alt": "var(--background-color-brand-primary_alt)",
		secondary_alt: "var(--background-color-secondary_alt)",
		overlay: "var(--background-color-overlay)",
		"brand-section": "var(--background-color-brand-section)",
		"brand-section_subtle": "var(--background-color-brand-section_subtle)",
		"primary-solid":
			"color-mix(in srgb, var(--background-color-primary-solid) calc(<alpha-value> * 100%), transparent)",
		"error-solid_hover": "var(--background-color-error-solid_hover)",
		"border-brand": "var(--background-color-border-brand)",
		"border-brand_alt": "var(--background-color-border-brand_alt)",
		primary:
			"color-mix(in srgb, var(--background-color-primary) calc(<alpha-value> * 100%), transparent)",
		secondary:
			"color-mix(in srgb, var(--background-color-secondary) calc(<alpha-value> * 100%), transparent)",
	},
	textColor: {
		secondary_hover: "var(--text-color-secondary_hover)",
		tertiary:
			"color-mix(in srgb, var(--text-color-tertiary) calc(<alpha-value> * 100%), transparent)",
		tertiary_hover: "var(--text-color-tertiary_hover)",
		"error-primary":
			"color-mix(in srgb, var(--text-color-error-primary) calc(<alpha-value> * 100%), transparent)",
		"warning-primary": "var(--text-color-warning-primary)",
		"success-primary": "var(--text-color-success-primary)",
		"brand-secondary":
			"color-mix(in srgb, var(--text-color-brand-secondary) calc(<alpha-value> * 100%), transparent)",
		placeholder: "var(--text-color-placeholder)",
		"brand-tertiary": "var(--text-color-brand-tertiary)",
		"editor-icon-fg": "var(--text-color-editor-icon-fg)",
		"editor-icon-fg_active": "var(--text-color-editor-icon-fg_active)",
		quaternary: "var(--text-color-quaternary)",
		"brand-primary": "var(--text-color-brand-primary)",
		"primary_on-brand": "var(--text-color-primary_on-brand)",
		"secondary_on-brand": "var(--text-color-secondary_on-brand)",
		"tertiary_on-brand": "var(--text-color-tertiary_on-brand)",
		"quaternary_on-brand": "var(--text-color-quaternary_on-brand)",
		"brand-tertiary_alt": "var(--text-color-brand-tertiary_alt)",
		"error-primary_hover": "var(--text-color-error-primary_hover)",
		"brand-secondary_hover": "var(--text-color-brand-secondary_hover)",
		"tooltip-supporting-text": "var(--text-color-tooltip-supporting-text)",
		primary:
			"color-mix(in srgb, var(--text-color-primary) calc(<alpha-value> * 100%), transparent)",
		secondary: "var(--text-color-secondary)",
	},
	borderColor: {
		secondary_alt: "var(--border-color-secondary_alt)",
		tertiary: "var(--border-color-tertiary)",
		error:
			"color-mix(in srgb, var(--border-color-error) calc(<alpha-value> * 100%), transparent)",
		warning:
			"color-mix(in srgb, var(--color-warning-300) calc(<alpha-value> * 100%), transparent)",
		error_subtle: "var(--border-color-error_subtle)",
		brand_alt: "var(--border-color-brand_alt)",
		"brand-solid": "var(--border-color-brand-solid)",
		"brand-solid_hover": "var(--border-color-brand-solid_hover)",
		primary: "var(--border-color-primary)",
		secondary:
			"color-mix(in srgb, var(--border-color-secondary) calc(<alpha-value> * 100%), transparent)",
		brand:
			"color-mix(in srgb, var(--border-color-brand) calc(<alpha-value> * 100%), transparent)",
	},
	ringColor: {
		secondary_alt: "var(--ring-color-secondary_alt)",
		tertiary: "var(--ring-color-tertiary)",
		error: "var(--ring-color-error)",
		error_subtle: "var(--ring-color-error_subtle)",
		brand_alt: "var(--ring-color-brand_alt)",
		"brand-solid":
			"color-mix(in srgb, var(--ring-color-brand-solid) calc(<alpha-value> * 100%), transparent)",
		"brand-solid_hover": "var(--ring-color-brand-solid_hover)",
		primary: "var(--ring-color-primary)",
		secondary:
			"color-mix(in srgb, var(--ring-color-secondary) calc(<alpha-value> * 100%), transparent)",
		brand: "var(--ring-color-brand)",
	},
	outlineColor: {
		secondary_alt: "var(--outline-color-secondary_alt)",
		tertiary: "var(--outline-color-tertiary)",
		error: "var(--outline-color-error)",
		error_subtle: "var(--outline-color-error_subtle)",
		brand_alt: "var(--outline-color-brand_alt)",
		"brand-solid": "var(--outline-color-brand-solid)",
		"brand-solid_hover": "var(--outline-color-brand-solid_hover)",
		primary: "var(--outline-color-primary)",
		secondary: "var(--outline-color-secondary)",
		brand: "var(--outline-color-brand)",
	},
	gradientColorStops: {
		primary:
			"color-mix(in srgb, var(--background-color-primary) calc(<alpha-value> * 100%), transparent)",
		secondary:
			"color-mix(in srgb, var(--background-color-secondary) calc(<alpha-value> * 100%), transparent)",
	},
	textDecorationColor: {
		"brand-secondary":
			"color-mix(in srgb, var(--text-color-brand-secondary) calc(<alpha-value> * 100%), transparent)",
	},
	ringOffsetColor: {
		primary: "var(--background-color-primary)",
	},
	boxShadow: {
		xs: "var(--shadow-xs)",
		sm: "var(--shadow-sm)",
		md: "var(--shadow-md)",
		lg: "var(--shadow-lg)",
		xl: "var(--shadow-xl)",
		"2xl": "var(--shadow-2xl)",
		"3xl": "var(--shadow-3xl)",
		skeuomorphic: "var(--shadow-skeuomorphic)",
		"xs-skeuomorphic": "var(--shadow-xs-skeuomorphic)",
		"modern-mockup-inner-lg": "var(--shadow-modern-mockup-inner-lg)",
		"modern-mockup-inner-md": "var(--shadow-modern-mockup-inner-md)",
		"modern-mockup-inner-sm": "var(--shadow-modern-mockup-inner-sm)",
		"modern-mockup-outer-lg": "var(--shadow-modern-mockup-outer-lg)",
		"modern-mockup-outer-md": "var(--shadow-modern-mockup-outer-md)",
	},
	fontSize: {
		xs: [
			"0.75rem",
			{
				lineHeight: "1.125rem",
			},
		],
		sm: [
			"0.875rem",
			{
				lineHeight: "1.25rem",
			},
		],
		md: [
			"1rem",
			{
				lineHeight: "1.5rem",
			},
		],
		lg: [
			"1.125rem",
			{
				lineHeight: "1.75rem",
			},
		],
		xl: [
			"1.25rem",
			{
				lineHeight: "1.875rem",
			},
		],
		"display-xs": [
			"1.5rem",
			{
				lineHeight: "2rem",
			},
		],
		"display-sm": [
			"1.875rem",
			{
				lineHeight: "2.375rem",
			},
		],
		"display-md": [
			"2.25rem",
			{
				lineHeight: "2.75rem",
				letterSpacing: "-0.72px",
			},
		],
		"display-lg": [
			"3rem",
			{
				lineHeight: "3.75rem",
				letterSpacing: "-0.96px",
			},
		],
		"display-xl": [
			"3.75rem",
			{
				lineHeight: "4.5rem",
				letterSpacing: "-1.2px",
			},
		],
		"display-2xl": [
			"4.5rem",
			{
				lineHeight: "5.625rem",
				letterSpacing: "-1.44px",
			},
		],
	},
} satisfies ThemeExtend;
